import "./EdutainmentPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const enrichData = [
  {
    title: "LEARN ART",
    items: [
      "Step-by- step art",
      "Sketch pen art",
      "Pencil art",
      "Grid art",
      "Pattern art",
      "Science art",
    ],
  },
  {
    title: "BRAINY ACTIVITIES",
    items: [
      "Puzzlink",
      "Find me out",
      "Odd one out",
      "Find my way",
      "Play ground",
      "Mazor",
    ],
  },
  {
    title: "SKILL SET MAGAZINES",
    items: [
      "Class 1 Magazine",
      "Class-2 Magazine",
      "Class-3 magazine",
      "Class-4 Magazine",
      "Class-5 Magazines",
      "Class-6 Magazines",
    ],
  },
  {
    title: "FUN SCIENCE",
    items: [
      "Experiment with water",
      "Experiment with Air",
      "Experiment with Magnet",
      "Experiment with paper",
      "Experiment with salt",
      "Experiment with sand",
    ],
  },
  {
    title: "NUMBER GAMES",
    items: [
      "Centre start Bala name",
      "More or Less",
      "Round up",
      "SUM thing special",
      "Metha magic",
      "Count on me",
    ],
  },
  {
    title: "ALPHA GAMES",
    items: [
      "Alphabet",
      "Name game",
      "Centre start",
      "Word hint",
      "Re write",
      "Words on wheel",
    ],
  },
];

export default function EnrichPage() {
  return (
    <div className="enrichWrapper" style={{backgroundColor:"#ffc488"}}>
      {enrichData.map((section) => (
        <div className="enrichColumn" key={section.title}>
          <div className="enrichHeading">
            <span className="enrichTitle">{section.title}</span>
          </div>

          <ul className="enrichList">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="enrichArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}